export default __webpack_public_path__ + "static/media/samuel.493202c9.jpg";